import { render, staticRenderFns } from "./seckillPage.vue?vue&type=template&id=325c4473&scoped=true&"
import script from "./seckillPage.vue?vue&type=script&lang=js&"
export * from "./seckillPage.vue?vue&type=script&lang=js&"
import style0 from "./seckillPage.vue?vue&type=style&index=0&id=325c4473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c4473",
  null
  
)

export default component.exports